import { useMemo } from 'react';
import type { Applicant, ApplicantFilter } from '../types/applicant';

export function useApplicantFilters(
  applicants: Applicant[],
  searchQuery: string,
  filters: ApplicantFilter
) {
  return useMemo(() => {
    let filteredApplicants = [...applicants];
    
    // Apply search query
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filteredApplicants = filteredApplicants.filter(applicant =>
        applicant.appl_name.toLowerCase().includes(query) ||
        (applicant.appl_email?.toLowerCase() || '').includes(query) ||
        (applicant.appl_phone || '').includes(query) ||
        (applicant.appl_cont_name?.toLowerCase() || '').includes(query)
      );
    }
    
    // Apply filters
    if (filters.name) {
      filteredApplicants = filteredApplicants.filter(applicant =>
        applicant.appl_name === filters.name
      );
    }
    
    if (filters.contactName) {
      filteredApplicants = filteredApplicants.filter(applicant =>
        applicant.appl_cont_name === filters.contactName
      );
    }
    
    if (filters.email) {
      filteredApplicants = filteredApplicants.filter(applicant =>
        applicant.appl_email === filters.email
      );
    }
    
    return filteredApplicants;
  }, [applicants, searchQuery, filters]);
}
